import {queryClient} from "~/plugins/vue-query";
import {PermissionModel} from "~/gen/openapi/portalService";

export function useAccountId() {
    const accounts = computed(() => queryClient.getQueryData(['accountGetAccountsByCurrentUser']) as Array<PermissionModel>)
    const route = useRoute()
    return computed(() => {
        const idFromRoute = route?.params?.accountId as string || ''

        if (route.path.includes('/fo/') || route.path.includes('/pl/') || route.path.includes('/ac/')) {
            return idFromRoute
        }

        const account = accounts.value?.find((a) => [a.EntrepreneurId, a.AccountId].includes(idFromRoute))
        return account?.EntrepreneurId || account?.AccountId || ''
    })
}
